<template>
    <v-card flat>
        <v-toolbar color="bal-gray" dense>
            <v-toolbar-title>{{
                    `${swiftToBankName(activeLogSwift)} logs`
                }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="resetActiveLogSwift()">
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab style="text-transform: none !important;">
                {{ "AIS logs" | t }}
            </v-tab>

            <v-tab-item>
                <consent-ais-company-logs-tab :loading="loading"/>
            </v-tab-item>
            <v-tab style="text-transform: none !important;">
                {{ "Bank logs" | t }}
            </v-tab>

            <v-tab-item>
                <consent-bank-logs-tab :loading="loading"/>
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import ConsentBankLogsTab from "@/components/consent/consent-bank-logs-tab";
import {bankMixin} from "@/mixins/bank-mixin";
import ConsentAisCompanyLogsTab from "@/components/consent/consent-ais-company-logs-tab";

export default {
    name: "consent-logs-view",
    mixins: [bankMixin],
    components: {ConsentAisCompanyLogsTab, ConsentBankLogsTab},
    data() {
        return {
            dialog: true,
            tab: 0,
            loading: true,
        }
    },
    computed: {
        ...mapState('ais', ['bankLogs', 'activeLogSwift']),
    },
    watch: {
        dialog: function () {
            if (!this.dialog) {
                this.resetActiveLogSwift();
            }
        }
    },
    async mounted() {
        this.loading = true;
        await this.getLogsData({swift: this.activeLogSwift});
        this.loading = false;
    },
    beforeDestroy() {
        this.resetActiveLogSwift();
    },
    methods: {
        ...mapMutations('ais', ['resetActiveLogSwift']),
        ...mapActions('ais', ['getLogsData']),
    }
}
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 2px;
    padding-bottom: 2px;
}
</style>